"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var userLens_1 = require("@caddigital/sok-reducers/lib/utils/userLens");
var avatars_1 = require("components/Avatar/avatars");
function getUserGroup(level) {
    switch (level) {
        case 'SuperAdminUserGroup':
            return (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/users/tabs/CompanyMembers/granoAdminUserGroup');
        case 'SalesmanUserGroup':
            return (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/users/tabs/CompanyMembers/salesmanUserGroup');
        case 'platiniumAdminUserGroup':
            return (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/users/tabs/CompanyMembers/platiniumAdminUserGroup');
        case 'premiumUserGroup':
            return (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/users/tabs/CompanyMembers/premiumUserGroup');
        default:
            return (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/users/tabs/CompanyMembers/normalUserGroup');
    }
}
var ListRow = function (r) {
    return (React.createElement(sok_ui_1.Table.Row, null,
        React.createElement(sok_ui_1.Table.Column, { className: 'user-logo-column' },
            React.createElement("img", { src: (0, avatars_1.getAvatarUrl)(r.row.avatar) })),
        React.createElement(sok_ui_1.Table.Column, { className: 'user-name', onClick: function () { return r.props.editUser(r.row, r.props.onCloseAction); } },
            React.createElement("abbr", { title: userLens_1.getName.get(r.row) }, userLens_1.getName.get(r.row))),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement("abbr", { title: r.row.email }, r.row.email)),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement("abbr", { title: r.row.company || undefined }, r.row.company)),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement("abbr", { title: getUserGroup(r.row.level) }, getUserGroup(r.row.level))),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement("abbr", { title: (0, translation_1.getLocalization)('admin/system/userManagement/project') },
                React.createElement(Icon_1.Icon, { className: 'edit-user fa-cog', onClick: function () { return r.props.toggleModal(r.row); } }))),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement("abbr", { title: (0, translation_1.getLocalization)('admin/system/userManagement/edit') },
                React.createElement(Icon_1.Icon, { className: 'edit-user fa-cog', onClick: function () { return r.props.editUser(r.row, r.props.onCloseAction); } })))));
};
exports.ListRow = ListRow;
